@if (!user()) {
  <app-header [user]="user()" />
}

<section class="www-pro-edu">
  <!-- <app-pro-education-top (onMoreClickEvent)="scrollToContent(content)" /> -->
  <app-pillar-top
    [bannerUrl]="'assets/images/pages/home/pro-edu-banner.webp'"
    [bannerMobUrl]="'assets/images/pages/home/pro-edu-banner-mob.webp'"
  />
  <div #content>
    <app-trainings-list
      [showPagination]="true"
      [trainingType]="TrainingType.TRAINING"
      [initCategory]="8"
      [isCategoriesFilterVisible]="false"
      [isBrandFilterVisible]="false"
      [isTrainingCategoriesFilterVisible]="false"
    />
  </div>

  <app-newsletter-section />
</section>
